<template>
    <div>
        <!-- Блок статистики выплат агентам -->
        <AgentSettlementStatistics />
        
        <AgentSettlementFinderAndCreator
            :key="componentRefreshKey"
            :isNeedCreate="true"
            :changed-item="changedItem"
            :additionalGetParameter="additionalGetParameter"
            :typeOfTableFilter="$route.params.settlement_type ? '' : 'agentSettlements'"
        />
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import AgentSettlementFinderAndCreator from '@/components/agentSettlements/AgentSettlementFinderAndCreator.vue'
    import AgentSettlementStatistics from '@/components/agentSettlements/AgentSettlementStatistics.vue'

    export default {
        components: {
            AgentSettlementFinderAndCreator,
            AgentSettlementStatistics,
        },
        props: {
            changedItem: {
                type: Object,
                default: () => {}
            }
        },
        data() {
            return {
                additionalGetParameter: '',
                componentRefreshKey: 0,
            }
        },
        computed: {
            ...mapGetters("auth", ["currentUser"]),
        },
        created() {
            this.additionalGetParameterChanger()
        },
        watch: {
            '$route.path'() {
                this.additionalGetParameterChanger()
            }
        },
        methods: {
            additionalGetParameterChanger() {
                if (this.$route.params.settlement_type) {
                    this.additionalGetParameter = `&settlement_type=${this.$route.params.settlement_type}`
                } else {
                    this.additionalGetParameter = ''
                }
                this.componentRefreshKey += 1
            },
        }
    }
</script> 